// Soltar un archivo sobre la aplicacion (5.1).
//
// **Por que sobre toda la aplicacion y no sobre el panel.** El panel puede
// estar cerrado -y lo normal es que lo este-, asi que un area de soltar dentro
// de el obligaria a abrirlo primero, que es el paso que este plan quita. Se
// suelta donde estes y el panel se abre solo.
//
// El contador existe porque `dragleave` salta **cada vez que el puntero cruza
// un hijo**, y sin llevar la cuenta el aviso parpadea al pasar por encima de
// cualquier cosa. Es el mismo motivo por el que se mira `dataTransfer.types`:
// arrastrar texto seleccionado tambien dispara `dragover`, y eso no es un
// archivo.

import { useCallback, useEffect, useRef, useState } from 'react'

function carriesFiles(event: DragEvent): boolean {
  return Array.from(event.dataTransfer?.types ?? []).includes('Files')
}

export function useFileDrop(onDrop: (file: File) => void) {
  const [dragging, setDragging] = useState(false)
  const depth = useRef(0)

  const handleDrop = useCallback(
    (event: DragEvent) => {
      if (!carriesFiles(event)) return
      event.preventDefault()
      depth.current = 0
      setDragging(false)
      const file = event.dataTransfer?.files?.[0]
      if (file) onDrop(file)
    },
    [onDrop],
  )

  useEffect(() => {
    const enter = (event: DragEvent) => {
      if (!carriesFiles(event)) return
      depth.current += 1
      setDragging(true)
    }
    const leave = (event: DragEvent) => {
      if (!carriesFiles(event)) return
      depth.current = Math.max(0, depth.current - 1)
      if (depth.current === 0) setDragging(false)
    }
    // Sin `preventDefault` en `dragover` el navegador abre el archivo en una
    // pestaña nueva y se lleva la aplicacion por delante.
    const over = (event: DragEvent) => {
      if (carriesFiles(event)) event.preventDefault()
    }

    window.addEventListener('dragenter', enter)
    window.addEventListener('dragleave', leave)
    window.addEventListener('dragover', over)
    window.addEventListener('drop', handleDrop)
    return () => {
      window.removeEventListener('dragenter', enter)
      window.removeEventListener('dragleave', leave)
      window.removeEventListener('dragover', over)
      window.removeEventListener('drop', handleDrop)
    }
  }, [handleDrop])

  return dragging
}
